<style src="./ContextSalePercFilter.scss" lang="scss"></style>
<template>
  <section class="context-sale-perc-filter">
    <div class="rowsection">
      <span class="filtertitle">Regras</span>
      <div class="filters">
        <span class="description">
          Aplicar percentual a todos
        </span>
        <form
          @submit.prevent="openModalConfirm"
          class="form cp1-input-group">
          <button
            class="appendbutton">
            <icon-right-arrow />
          </button>
          <input
            type="text"
            v-model="addPercentual"
            placeholder="25"
            class="appendtextbox" />
        </form>
      </div>
    </div>

    <modal
      transition="nice-modal-fade"
      name="modalConfirmAddSalePerc"
      width="500px"
      height="auto">
      <aside class="modal-confirm">
        <icon-danger class="illustration" />
        <div class="description">
          <p class="info">
            Essa ação irá aplicar <strong>{{addPercentual}}%</strong> nos itens exibidos. Tem certeza que deseja continuar?
          </p>
        </div>

        <section class="cmdcancel">
          <button
            type="button"
            @click="cancelApply"
            class="btn-ghost">Cancelar ação</button>
        </section>
        <form
          @submit.prevent="applyPercentual"
          class="cmdapply">

          <button-submit
            label="Sim, pode alterar os valores"
            :state="commands.submitState"
            :icon-save="commands.saveIcon" />
        </form>
      </aside>
    </modal>
  </section>
</template>

<script>
import { ButtonSubmit } from '@/components/primitives'
import { IconRightArrow, IconDanger, IconSave } from '@/components/primitives/icons'
import CalculatePercentualByField from '../../helpers/CalculatePercentualByField'

export default {
  name: 'ContextSalePercFilter',
  components: {
    ButtonSubmit,
    IconRightArrow,
    IconDanger,
    IconSave
  },
  data: () => ({
    addPercentual: 20,
    commands: {
      submitState: 'REPOSE',
      saveIcon: IconSave
    }
  }),
  mounted () {},
  methods: {
    cancelApply () {
      this.$modal.hide('modalConfirmAddSalePerc')
    },
    openModalConfirm () {
      this.$modal.show('modalConfirmAddSalePerc')
    },
    async applyPercentual () {
      this.commands.submitState = 'WAIT'

      const calculateSalePerc = CalculatePercentualByField('proposal', this.addPercentual)
      const payload = this.$store.getters['ItemPricing/FILTERED_LIST']
        .map(calculateSalePerc)
        .filter(i => !!i)

      this.$store.commit('ItemPricing/SET_ALL_SALES_VALUE', {
        field: 'proposal',
        percentual: this.addPercentual,
        items: payload
      })

      try {
        await this.$store.dispatch('ItemPricing/UPDATE_SALE_LIST', { payload })

        this.$toasted.success('Atualização salva com sucesso!')
      } catch (error) {
        this.$toasted.error(error)
      } finally {
        this.commands.submitState = 'REPOSE'
        this.$modal.hide('modalConfirmAddSalePerc')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/context-sale-perc-filter/ContextSalePercFilter.vue